import { render, staticRenderFns } from "./UpcomingCompanyHolidaysCreated.vue?vue&type=template&id=488fff26"
import script from "./UpcomingCompanyHolidaysCreated.vue?vue&type=script&lang=js"
export * from "./UpcomingCompanyHolidaysCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports